import { useCallback, useRef, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Botao } from '../../components/Botao';
import { CorpoDaPagina } from '../../components/CorpoDaPagina';
import { Icone } from '../../components/Icone';
import { Input } from '../../components/Input';
import { Modal } from '../../components/Modal';
import { Seletor } from '../../components/Seletor';
import { Tabela } from '../../components/Tabela';
import { converterBlobParaJson } from '../../functions/conversorHelper';
import { InstituicaoStore } from '../../stores/InstituicaoStore';
import { MunicipioStore } from '../../stores/MunicipioStore';
import { Formulario, InputContainer, ConteinerBotoes } from './styles';

function Instituicao() {
  const [filtros, atribuirFiltros] = useState({});
  const [instituicoes, atribuirInstituicoes] = useState([]);
  const [opcoesModal, atribuirOpcoesModal] = useState({ open: false });
  const [municipios, atribuirMunicipios] = useState([]);
  const [parametros, atribuirParametros] = useState({
    pagina: 1,
    registroPorPagina: 30,
    ordenarDecrescente: false,
  });
  const [totalPaginas, setTotalPaginas] = useState(0);
  const [totalRegistro, setTotalRegistro] = useState(0);

  const formRef = useRef(null);

  const historico = useHistory();

  const enviar = useCallback((data) => {
    atribuirFiltros(data);
  }, []);

  const abrirModal = (instituicao) => {
    atribuirOpcoesModal({ open: true, instituicao: instituicao });
  };

  const acoesModalAtivar = (
    <>
      <Botao
        texto='Cancelar'
        aoClicar={() => atribuirOpcoesModal({ open: false })}
        cor='background'
      />
      <Botao
        texto='Ativar'
        aoClicar={() => ativarOuInativar(opcoesModal.instituicao)}
        cor='success'
      />
    </>
  );

  const acoesModalInativar = (
    <>
      <Botao
        texto='Cancelar'
        aoClicar={() => atribuirOpcoesModal({ open: false })}
        cor='background'
      />
      <Botao
        texto='Inativar'
        aoClicar={() => ativarOuInativar(opcoesModal.instituicao)}
        cor='danger'
      />
    </>
  );

  const redirecionar = (item, link) => {
    historico.push(item ? `${link}${item.id}` : link);
  };

  const acoesRegistroTabela = [
    {
      texto: '',
      icone: 'FaEye',
      cor: 'info',
      aoClicar: redirecionar,
      redirecionar: '/instituicao/visualizar/',
      retornarObjeto: true,
      tooltip: 'Visualizar',
    },
    {
      texto: '',
      icone: 'FaPen',
      cor: 'warning',
      aoClicar: redirecionar,
      redirecionar: '/instituicao/editar/',
      retornarObjeto: true,
      tooltip: 'Editar',
    },
    {
      texto: '',
      icone: 'FaTimes',
      cor: 'danger',
      aoClicar: abrirModal,
      retornarObjeto: true,
      valorDependencia: true,
      campoDependencia: 'situacao',
      tooltip: 'Inativar',
    },
    {
      texto: '',
      icone: 'FaCheck',
      cor: 'success',
      aoClicar: abrirModal,
      retornarObjeto: true,
      valorDependencia: false,
      campoDependencia: 'situacao',
      tooltip: 'Ativar',
    },
  ];

  const acoesTabela = (
    <Botao
      cor='success'
      texto='Nova instituição'
      aoClicar={() => redirecionar(undefined, '/instituicao/nova')}
    >
      <Icone nome='FaPlus' tamanho={16} />
    </Botao>
  );

  const ativarOuInativar = useCallback(
    async (instituicao) => {
      InstituicaoStore.ativarOuInativar(instituicao.id, !instituicao.situacao).then((response) => {
        if (response.status === 200) {
          toast.success(response.data.mensagem);
          atribuirParametros({ ...parametros });
        } else if (response.status >= 400 && response.status < 500)
          toast.error(response.data.mensagem);
        else toast.error(response.data.message);

        atribuirOpcoesModal({ open: false });
      });
    },
    [parametros],
  );

  const baixarRelatorio = async () => {
    const response = await InstituicaoStore.obterRelatorioInstituicaoAprovadores(filtros);

    if (response.status === 200) {
      const href = URL.createObjectURL(response.data);

      const link = document.createElement('a');
      link.href = href;

      link.setAttribute('download', 'RelatorioInstituicoesAprovadores.csv');
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      URL.revokeObjectURL(href);
    } else {
      const json = await converterBlobParaJson(response.data);
      toast.warning(json.mensagem);
    }
  };

  const controlarModal = () => {
    atribuirOpcoesModal({ open: false });
  };

  const colunas = [
    { nome: 'Nome', propriedade: 'nome', ordenavel: true, largura: '35%', filtrado: true },
    {
      nome: 'Dependência administrativa',
      propriedade: 'dependenciaAdministrativa',
      ordenavel: true,
      largura: '25%',
      filtrado: true,
    },
    {
      nome: 'Município',
      propriedade: 'municipio',
      ordenavel: true,
      largura: '15%',
      filtrado: true,
    },
    {
      nome: 'Situação',
      propriedade: 'situacao',
      ordenavel: true,
      largura: '10%',
      filtrado: true,
      booleano: true,
    },
  ];

  const limparFiltros = () => {
    formRef.current.reset();
    atribuirFiltros({});
  };

  const mudarPagina = (param) => {
    atribuirParametros({ ...parametros, pagina: param });
  };

  useEffect(() => {
    const callView = async () => {
      await MunicipioStore.obterMunicipios().then((response) => {
        if (response.status === 200) {
          atribuirMunicipios([
            { label: 'Todos', value: '' },
            ...response.data.map((item) => ({ label: item.nome, value: item.nome })),
          ]);
        } else if (response.status === 204) {
          toast.error('Não há municípios cadastrados');
        } else toast.error(response.data.mensagem);
      });
    };

    callView();
  }, []);

  useEffect(() => {
    InstituicaoStore.obterFiltradaPaginada({ ...parametros, ...filtros }).then((response) => {
      if (response.status === 200) {
        atribuirInstituicoes(
          response.data.lista.map((instituicao) => ({
            nome: instituicao.nome,
            dependenciaAdministrativa: instituicao.dependenciaAdministrativa,
            municipio: instituicao.cidade,
            situacao: instituicao.ativo,
            publica: instituicao.publica,
            id: instituicao.id,
          })),
        );
        setTotalPaginas(response.data.totalDePaginas);
        setTotalRegistro(response.data.totalDeRegistros);
      } else {
        toast.error(response.data.mensagem);
      }
    });
  }, [filtros, parametros]);

  return (
    <CorpoDaPagina titulo='Instituições'>
      <Formulario ref={formRef} onSubmit={enviar}>
        <InputContainer>
          <Input titulo='Instituição de ensino' nome='nome' placeholder={'Informe o nome'} />

          <Seletor
            nome='grauEscolaridade'
            titulo='Etapa ou modalidade de ensino'
            opcoes={[
              { label: 'Todos', value: '' },
              { label: 'EAD - Superior', value: 'EADSuperior' },
              { label: 'Presencial - Superior', value: 'Superior' },
              { label: 'Ensino Fundamental', value: 'Fundamental' },
              { label: 'Ensino Médio', value: 'Médio' },
              { label: 'Educação de Jovens Adultos', value: 'eja' },
              { label: 'Educação Profissional', value: 'Profissional' },
              { label: 'Educação Infantil', value: 'Infantil' },
            ]}
          />
          <Seletor
            nome='dependenciaAdministrativa'
            titulo='Dependência administrativa'
            opcoes={[
              { label: 'Todas', value: '' },
              { label: 'Federal', value: 'Federal' },
              { label: 'Privada', value: 'Privada' },
              { label: 'Municipal', value: 'Municipal' },
              { label: 'Estadual', value: 'Estadual' },
            ]}
          />
          <Seletor nome='municipio' titulo='Município' opcoes={municipios} />
        </InputContainer>
        <ConteinerBotoes>
          <Botao texto='Limpar filtros' cor='danger' outlined aoClicar={() => limparFiltros()} />
          <Botao texto='Gerar Relatório' cor='dark_darker' aoClicar={() => baixarRelatorio()} />
          <Botao texto='Filtrar' tipo='submit' />
        </ConteinerBotoes>
      </Formulario>
      <Tabela
        colunas={colunas}
        acoesDoRegistro={acoesRegistroTabela}
        dados={instituicoes}
        acoesDaTabela={acoesTabela}
        aoMudarDePagina={mudarPagina}
        totalDePaginas={totalPaginas}
        totalDeRegistros={totalRegistro}
        registrosPorPagina={parametros.registroPorPagina}
        aoOrdenar={(column, desc) =>
          atribuirParametros({ ...parametros, ordenarPor: column, ordenarDecrescente: desc })
        }
        ordenacaoDecresente={parametros.ordenarDecrescente}
        ordenarPor={parametros.ordenarPor}
      />
      {opcoesModal.open && (
        <Modal
          titulo={`${opcoesModal.instituicao.situacao ? 'Inativar' : 'Ativar'} instituição`}
          acoes={opcoesModal.instituicao.situacao ? acoesModalInativar : acoesModalAtivar}
          controleAberturaModal={controlarModal}
        >
          <span>
            Deseja {opcoesModal.instituicao.situacao ? 'inativar' : 'ativar'} esta instituição?
          </span>
        </Modal>
      )}
    </CorpoDaPagina>
  );
}

export default Instituicao;
